import React, { useEffect } from "react";
import WOW from "wowjs";
import { useMediaQuery } from "Components/Custom_hooks/Custom";
function Results() {
  const isMobile = useMediaQuery("(max-width:700px)");

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const results = [
    {
      id: "r1",
      image: "/assets/img/results/icon1.png",
      score: "Maths - 800/800",
      name: "AMIRA",
      review:
        "One-on-one mentoring and adaptive mock tests helped me outperform my expectations.",
      video: "/assets/gallery/video1.mp4",
      delay: ".2s",
    },

    {
      id: "r2",
      image: "/assets/img/results/icon2.png",
      score: "Maths - 800/800",
      name: "STUDENT",
      review:
        "Structured strategy, consistent reviews, and personal mentorship made all the difference.",
      video: "/assets/gallery/video2.mp4",
      delay: ".4s",
    },

    {
      id: "r3",
      image: "/assets/img/results/icon3.png",
      score: "SAT - 1490",
      name: "GAURI",
      review:
        "Crystal-clear explanations and exam-focused practice gave me complete confidence.",
      video: "/assets/gallery/video3.mp4",
      delay: ".6s",
    },
  ];

  return (
    <section id="results" className="results-adv pt-100 pb-100">
      <div className="container">
        <h2 className="wow fadeInUp" data-wow-delay=".2s">
          Our Results
        </h2>
        <p className="results-sub wow fadeInUp" data-wow-delay=".3s">
          Exceptional scores backed by real student stories
        </p>
        <div className="results-grid">
          {results.map((item, index) => (
            <div
              key={index}
              className="result-card wow fadeInUp"
              data-wow-delay={item.delay}
            >
              <input type="radio" name="video" id={item.id} hidden />

              <div className="card-bg"></div>

              <img
                src={item.image}
                alt={item.name}
                className="student-img"
                style={{ marginLeft: !isMobile ? "36%" : "25%" }}
              />

              <div className="score">{item.score}</div>

              <div
                className="score"
                style={{
                  color: "black",
                  fontSize: "22px",
                  marginTop: "-5px",
                }}
              >
                {item.name}
              </div>

              <p className="review">{item.review}</p>

              <label htmlFor={item.id} className="video-btn">
                ▶ Watch Story
              </label>

              <div className="video-box">
                <video controls>
                  <source src={item.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Results;
